// Cloudflare Turnstile Site Key (public key - safe to expose in frontend)
export const TURNSTILE_SITE_KEY = '0x4AAAAAACEcAQHllJ3rcu1k';
